import { useField } from 'formik';
import React from 'react';
import { SelectTariff } from './SelectTariff';
import { Props } from './SelectTariff';

interface FormProps {
    name: string;
}

export const FormSelectTariff: React.FC<
    FormProps & Omit<Props, 'value' | 'onChange'>
> = ({ name, ...props }) => {
    const [field, , helpers] = useField(name);
    return (
        <SelectTariff
            {...props}
            value={field.value}
            onChange={helpers.setValue}
        />
    );
};
